webpackJsonp([79],{

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1241);


/***/ }),

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(157);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(745);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1240]);


// WEBPACK FOOTER //
// app/datetime.en-62df5a2776fc4824ce98.js